import type { ShortcutJs } from "@/generated/models";
import { queryOptions, skipToken } from "@tanstack/vue-query";
import { getBookmark } from "ls/api/cloud/bookmark";
import { isShortcutJs } from "ls/common/entity-schemas";
import { STALE } from "ls/queries/staleTime";
import { getUrlMetadata } from "../disko/api/urlMetadata";
import { queries as fileQueries } from "../files/queries";
import { isBookmarkShortcut } from "../files/utils";

export const queries = {
  bookmark: (shortcut: ShortcutJs | string) => {
    const shortcutValue = isShortcutJs(shortcut) ? shortcut.Shortcut : shortcut;
    const enabled = isShortcutJs(shortcut) ? isBookmarkShortcut(shortcut) : true;
    return queryOptions({
      queryKey: [...fileQueries.file(shortcutValue), "bookmark"] as const,
      enabled,
      queryFn: ({ signal }) => getBookmark(shortcutValue.toLowerCase(), { signal }),
      staleTime: STALE.MINUTES.ONE,
    });
  },
  urlMetadata: (url: string | undefined) =>
    queryOptions({
      queryKey: ["metadata", url],
      queryFn: url ? ({ signal }) => getUrlMetadata(url, { signal }) : skipToken,
      staleTime: Number.POSITIVE_INFINITY,
    }),
};
